import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-968e74da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notification-title" }
const _hoisted_2 = { class: "notification-content" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "controls" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "すべて削除", -1))

import { ref, computed } from 'vue'
import { useNotification, NotificationsOptions } from '@kyvg/vue3-notification'
import { useGlobalStore } from '@/stores/globalStore'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const globalStore = useGlobalStore()
const notification = useNotification()
const mute = ref<boolean>()
const notificationsComponent = ref()
const hasNotifications = computed(() => {
  return notificationsComponent.value && notificationsComponent.value.list.length > 0
})
const bellIcon = computed(() => {
  return mute.value ? 'fa-bell' : 'fa-bell-slash'
})
const muteText = computed(() => {
  return mute.value ? '音声再生' : '音声停止'
})
const bodyStyle = (item: NotificationsOptions) => {
  return {
    color: item.color,
    backgroundColor: item.backgroundColor,
  }
}
const onClickBell = () => {
  mute.value = !mute.value
  globalStore.soundPlayer.setMute(mute.value)
}
const onCloseAll = () => {
  notification.notify.closeAll()
  mute.value = true
  globalStore.soundPlayer.setMute(true)
}
const onClose = () => {
  mute.value = true
  globalStore.soundPlayer.setMute(true)
}
const onStart = () => {
  mute.value = false
  globalStore.soundPlayer.setMute(false)
}

return (_ctx: any,_cache: any) => {
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_notifications = _resolveComponent("notifications", true)!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_notifications, {
      onStart: onStart,
      ref_key: "notificationsComponent",
      ref: notificationsComponent,
      position: "bottom right"
    }, {
      body: _withCtx((props) => [
        _createElementVNode("div", {
          style: _normalizeStyle(bodyStyle(props.item)),
          class: "vue-notification-template vue-notification"
        }, [
          _createElementVNode("div", _hoisted_1, _toDisplayString(props.item.title), 1),
          _createElementVNode("div", _hoisted_2, _toDisplayString(props.item.text), 1),
          _createElementVNode("div", {
            onClick: ($event: any) => (props.close() || onClose()),
            class: "btn-close"
          }, [
            _createVNode(_component_fa_icon, {
              icon: "fa-close",
              size: "lg"
            })
          ], 8, _hoisted_3)
        ], 4)
      ]),
      _: 1
    }, 512),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: "btn",
            onClick: onClickBell
          }, [
            _createVNode(_component_fa_icon, {
              icon: _unref(bellIcon),
              size: "lg"
            }, null, 8, ["icon"]),
            _createElementVNode("span", null, _toDisplayString(_unref(muteText)), 1)
          ]),
          _createElementVNode("div", {
            class: "btn",
            onClick: onCloseAll
          }, [
            _createVNode(_component_fa_icon, {
              icon: "fa-close",
              size: "lg"
            }),
            _hoisted_5
          ])
        ], 512), [
          [_vShow, _unref(hasNotifications)]
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})